import FaultTypesTemplate from './FaultTypesTemplate.vue'
export default FaultTypesTemplate


// WEBPACK FOOTER //
// ./src/pages/FaultTypesTemplate/index.js